import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BillingService, Currency, Purchase } from '@galaxy/billing';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'billing-ui-retry-purchase-dialog',
  templateUrl: './retry-purchase-dialog.component.html',
  standalone: false,
})
export class RetryPurchaseDialogComponent implements OnInit {
  purchase: Purchase;
  loading = false;

  usd = Currency.USD;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: RetryPurchaseData,
    private dialogRef: MatDialogRef<RetryPurchaseDialogComponent>,
    private alertService: SnackbarService,
    private billingService: BillingService,
  ) {}

  ngOnInit(): void {
    this.purchase = this.data.purchase;
  }

  retryPurchase(): void {
    this.loading = true;
    const day = moment.utc(this.purchase.timestamp).format('YYYYMMDD');
    this.billingService
      .retryPurchase(this.purchase.merchantId, day, this.purchase.purchaseId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        () => {
          this.dialogRef.close(true);
          this.alertService.openSuccessSnack('Retry kicked off. Check back shortly to see if it was successful.');
        },
        () => this.alertService.openErrorSnack('Failed to retry purchase'),
      );
  }
}

interface RetryPurchaseData {
  purchase: Purchase;
}
